// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flex[data-v-aa97488e]{display:flex;align-items:center}.flex.j_cont_sp[data-v-aa97488e]{justify-content:space-between}.flex.j_cont_sa[data-v-aa97488e]{justify-content:space-around}", ""]);
// Exports
module.exports = exports;
